export default __webpack_public_path__ + "static/media/ktp900f.61e830fd.png";